import styled from 'styled-components';

export const Wrapper = styled.div`
  .year {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    .year-prev,
    .year-next {
      height: 16px;
      width: 16px;
      cursor: pointer;
      color: #d5def2;

      &:hover {
        color: var(--color-link);
      }
    }
    .year-current {
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 130%;
      letter-spacing: 0.01em;
      color: var(--color-text-muted);
      white-space: nowrap;
      display: flex;
      align-items: center;
    }
  }

  .months {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    .month {
      border: 2px solid #d5def2;
      border-radius: 5px;
      font-weight: 600;
      font-size: 12px;
      line-height: 150%;
      letter-spacing: 0;
      text-align: center;
      width: 95px;
      padding: 8px 10px;
      color: #d5def2;
      cursor: pointer;

      &:hover {
        border: 2px solid #40608f;
        color: var(--color-link);
      }

      &.active {
        border: 2px solid #858dbd;
        color: var(--color-text-muted);
      }
    }
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: flex-start;

    button {
      width: 130px;
    }
  }
`;
